import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a276c01a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-result-page" }
const _hoisted_2 = { class: "campaign-result-page__header" }
const _hoisted_3 = { class: "title flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, ">", -1))
const _hoisted_5 = { class: "flex justify-content-end flex-wrap" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }

import { AxiosResponse } from "axios";
import { CampaignServices } from "@/clinic/services";
import { DEFAULT_PAGINATOR_ROWS } from "../typings/constants/paginator";
import { get, set } from "@vueuse/core";
import { notifySuccessMsg, notityErrorMsg } from "../utils/notify-utils";
import { ref, computed, onBeforeMount } from "vue";
import { useConfirm } from "primevue/useconfirm";
import { useRoute } from "vue-router";
import { useToast } from "primevue/usetoast";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import { PageState } from "primevue/paginator";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import RouterConstants from "../constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import Toast from "primevue/toast";
import type {
  ApiBasePaginatorReq,
  ApiCampaignMessageRes,
  ApiCampaignShowReq,
  ApiCampaignBaseReq,
} from "@/clinic/typings";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignResult',
  setup(__props) {

const route = useRoute();
const toast = useToast();
const confirm = useConfirm();
const store = useStore();

const loading = ref(true);
const datasRsp = ref([]);
const campaignName = ref("");
const campaignStatus = ref("");
const name = ref("");
const columns = [
  { field: "index", header: "回数" },
  { field: "status", header: "ステータス" },
  { field: "requested_at", header: "配信日時" },
  { field: "number_of_bookings", header: "配信数（配信予定人数)", class: "col-2" },
  { field: "number_of_impression_percent", header: "開封数/率" },
  { field: "number_of_openings_percent", header: "クリック数/率" },
  { field: "number_of_bookings_percent", header: "予約完了数/率" },
  { field: "number_of_visited_target", header: "実来店数/率" },
  { field: "average_booking_price", header: "CV平均単価" },
  { field: "average_visited", header: "CV平均来店数" },
];
const first = ref(0);
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const page = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);
const channelId = ref(0);

const paginatorParams = computed(
  (): ApiBasePaginatorReq => ({ page: get(page), rows: get(rows) } as ApiBasePaginatorReq)
);

const formatPercentage = (a: number, b: number) => {
  const calculate = (a / b) * 100;
  if (calculate % 2 !== 0) {
    return calculate.toFixed(2);
  } else {
    return calculate;
  }
};

const formatDateTime = (input: string): string => {
  if (!input) return "";

  const date = new Date(input);

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();

  const formattedDate = `${year}/${month}/${day}`;
  const formattedTime = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;

  return `${formattedDate} ${formattedTime}`;
};

const idUrl = computed((): number => {
  const { params } = route;
  const { id } = params;
  return id as unknown as number;
});

const channelIdParam = async (): Promise<ApiCampaignBaseReq> => ({
  channel_id: await get(channelId),
});

const onBack = () => {
  return RouterUtils.goTo(RouterConstants.CAMPAIGN_ROUTER_NAME);
};

const onConfirmCancel = async (id: number) => {
  confirm.require({
    message: "配信停止してもよろしいですか？",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-danger",
    accept: async () => {
      await CampaignServices.cancelCampaign(
        { id, ...(await channelIdParam()) } as ApiCampaignShowReq,
        () => {
          notifySuccessMsg(toast, "配信中");
          onBack();
        },
        (error: any) => notityErrorMsg(toast, "エラー")
      );
    },
  });
};

const onConfirmDelivery = async (id: number) => {
  confirm.require({
    message: "このキャンペーンを配信しますか？",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-danger",
    accept: async () => {
      await CampaignServices.deliverCampaign(
        { id, ...(await channelIdParam()) } as ApiCampaignShowReq,
        () => {
          notifySuccessMsg(toast, "配信中");
          onBack();
        },
        (error: any) => notityErrorMsg(toast, "エラー")
      );
    },
  });
};

const onConfirmDelete = async (id: number) => {
  confirm.require({
    message: "このキャンペーンを削除しますか?",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-danger",
    accept: async () => {
      await CampaignServices.deleteCampaign(
        { id, ...(await channelIdParam()) } as ApiCampaignShowReq,
        () => {
          notifySuccessMsg(toast, "配信中");
          onBack();
        },
        (error: any) => notityErrorMsg(toast, "エラー")
      );
    },
  });
};

const paging = async (fromId: string, { page: newPage }: PageState) => {
  const pgRef = fromId == "pg-top" ? get(pgBot)?.getPagination() : get(pgTop)?.getPagination();
  if (newPage == pgRef?.page) return;

  get(pgRef)?.changePage(newPage);
  set(page, newPage);
  await loadCampaignMessage();
};

const loadCampaignMessage = async () => {
  set(loading, true);
  const campaignIdParams = {
    id: get(idUrl),
  };

  const { data } = (await CampaignServices.getCampaignMessage(
    { ...campaignIdParams, ...get(paginatorParams) } as ApiCampaignShowReq,
    () => undefined,
    () => undefined,
    () => set(loading, false)
  )) as unknown as AxiosResponse<ApiCampaignMessageRes>;
  const { total_count } = get(data).meta;
  set(datasRsp, get(data).messages.reverse());
  set(campaignName, get(data).messages[0].campaign_name);
  set(campaignStatus, get(data).messages[0].campaign_status);
  set(totalCount, get(total_count));
};

onBeforeMount(async () => {
  set(channelId, await store.dispatch("authClient/getChannelIdCookie"));
  loadCampaignMessage();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createVNode(_component_Button, {
            class: "p-button-link",
            label: "戻る",
            onClick: onBack
          }),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(campaignName.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (campaignStatus.value == 'draft' || campaignStatus.value == 'shipping')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-pause",
              class: "p-button-warning",
              label: "配信停止",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onConfirmCancel(_unref(idUrl))))
            }))
          : _createCommentVNode("", true),
        (campaignStatus.value == 'draft' || campaignStatus.value == 'canceled')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "pi pi-fast-forward",
              class: "p-button-success ml-2",
              label: "配信開始",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onConfirmDelivery(_unref(idUrl))))
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          icon: "pi pi-trash",
          class: "p-button-danger ml-2",
          label: "無効",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onConfirmDelete(_unref(idUrl))))
        })
      ]),
      _createVNode(Grid, {
        items: datasRsp.value,
        columns: columns,
        loading: loading.value
      }, {
        index: _withCtx(({ index }) => [
          _createElementVNode("span", null, _toDisplayString(Math.abs(index - totalCount.value)) + "回目", 1)
        ]),
        status: _withCtx(({ data }) => [
          (data.status == 'canceled')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "キャンセル"))
            : (data.status == 'undelivered')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "未配信"))
              : (data.status == 'delivered')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "配信済"))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
        ]),
        requested_at: _withCtx(({ data }) => [
          (data.requested_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(formatDateTime(data.requested_at)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
        ]),
        number_of_impression_percent: _withCtx(({ data }) => [
          (data.number_of_impression && data.targets)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(data.number_of_impression) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_impression, data.targets))) + "%", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
        ]),
        number_of_bookings: _withCtx(({ data }) => [
          (data.number_of_bookings)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(data.number_of_bookings), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
        ]),
        number_of_openings_percent: _withCtx(({ data }) => [
          (data.number_of_openings && data.targets)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(data.number_of_openings) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_openings, data.targets))) + "%", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
        ]),
        number_of_bookings_percent: _withCtx(({ data }) => [
          (data.number_of_completed_bookings && data.targets)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(data.number_of_bookings) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_bookings, data.targets))) + "%", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
        ]),
        number_of_visited_target: _withCtx(({ data }) => [
          (data.number_of_visited && data.targets)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(data.number_of_visited) + "/" + _toDisplayString(_unref(get)(formatPercentage(data.number_of_visited, data.targets))) + "%", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))
        ]),
        average_booking_price: _withCtx(({ data }) => [
          (data.average_booking_price)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "¥" + _toDisplayString(data.number_of_visited), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
        ]),
        average_visited: _withCtx(({ data }) => [
          (data.average_visited)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(data.average_visited) + "回 ", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
        ]),
        _: 1
      }, 8, ["items", "loading"])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})